import type { Menu } from '#/global'

const menus: Menu.recordRaw[] = [
  {
    meta: {
      title: '抖音核销售后',
      icon: 'heroicons-solid:currency-dollar',
    },
    path: '/douyin/after_sale',
  },
]

export default menus
